<template>
    <div class="modal">
        <div class="modal-container">
            <div class="modal-header">
                <close-icon v-on:click="closeView"></close-icon>
                <h1>Press Release Schedule</h1>
            </div>

            <div class="modal-body no-pad">
                <div class="flex h-full">
                    <div class="w-full md:pr-4">
                        <div class="account-body">
                            <form v-if="scheduleData">

                                <div class="form-field styled">
                                    <label class="text-sm">Media List</label>
                                    <input type="text" v-model="scheduleData.medialistTitle" name="medialistTitle"
                                           disabled="disabled" />
                                </div>

                                <div class="form-field styled">
                                    <label class="text-sm">Release Date</label>

                                    <simple-date-time-picker
                                        v-model="scheduleData.release">
                                    </simple-date-time-picker>
                                </div>

                                <div class="form-field styled">
                                    <label class="text-sm">Processed Date</label>

                                    <simple-date-time-picker
                                        v-model="scheduleData.processed">
                                    </simple-date-time-picker>
                                </div>

                            </form>
                        </div>
                    </div>

                    <div class="w-full md:w-1/2 md:pl-4">

                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <div class="flex">
                    <div class="left text-left">

                    </div>

                    <div class="middle text-middle">

                    </div>

                    <div class="right text-right">
                        <button class="btn-tertiary muted" type="button" @click="closeView">Close</button>
                        <button class="btn-primary" type="button" @click="saveForm">Save</button>
                    </div>
                </div>
            </div>

            <router-view v-slot="{ Component }">
                <transition name="drop-in" mode="in-out">
                    <component :is="Component"></component>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<script>

export default {
    name: "PressReleaseScheduleView",
    props: {
        schedule: {
            required: true,
        }
    },
    data() {
        return {
            scheduleData: {}
        }
    },
    mounted() {
        this.setMetaTitle('View Schedule | JournoLink Control')
        this.loadData();

        window.addEventListener('keyup', this.handleKeypress)
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.handleKeypress)
    },
    methods: {
        loadData() {
            axios.get(route('releases.schedule.get', [this.$route.params.releaseId, this.schedule]))
                .then((response) => {
                    this.scheduleData = response.data
                })
        },
        saveForm() {
            axios.post(route('releases.schedule', [this.$route.params.releaseId, this.scheduleData.id]), this.scheduleData)
                .then(response => {
                    this.$bus.$emit('alert.success', 'Update Success')
                    this.closeView()
                })
                .catch(e => {
                    this.$bus.$emit('alert.danger', 'Update Failed')
                })
        },
        /**
         * Emit the close event to the parent
         *
         * @return {void}
         */
        closeView() {
            this.$root.goBack()
        },
    }
}
</script>

<style lang="less">
.vdp-datepicker {
    display: inline-block;
    border: 1px solid #dddddd;
    padding: 5px;
}

.modal-body {
    h2, h3 {
        text-transform: uppercase;
        font-size: 1.2em;
        letter-spacing: .08em;
        color: #34495e;
        margin-bottom: 10px;
    }
}

p.note {
    margin: 10px 0;
    font-weight: bold;
}
</style>
